import { toast } from "react-toastify";

export const getFontsTemplate = async () => {
  const template = [
    {
      title: "Font Name",
      url: "https://example.com/font.woff",
      weight: 700,
      type: "serif",
    },
    {
      title: "Font Name",
      url: "https://example.com/font.woff",
      weight: 500,
      type: "sans-serif",
    },
    {
      title: "Font Name",
      url: "https://example.com/font.woff",
      weight: 400,
      type: "sans-serif",
    },
  ];

  await navigator.clipboard.writeText(JSON.stringify(template, null, 2));
  toast.success("Fonts template copied to clipboard");
};
